import $ from 'jquery';
import log from '../tools/log'

const section = '[data-video-section]'; 
const slide = '[data-video]';
const $header = $('#site-header');
const mq = window.matchMedia('(max-width: 767px)');
let player;


let pageHeight, headerHeight, sectionHeight;
let topCoordinates = [];
let idx = 0;

const reset = () => {
  headerHeight, pageHeight, sectionHeight = 0;
  // $(slider).removeClass('is-fixed is-hidden');
  showSlide('all');
  $(section).css('height', 'auto');
  idx = 0;
}

const isVisible = function ($element) {
  return $element.is(':visible');
};

const init = () => {
  reset();

  setTimeout(() => {
    headerHeight = $header.outerHeight();       //log({headerHeight});
    pageHeight = $(window).outerHeight() - headerHeight;       //log({pageHeight});
    sectionHeight = getSectionHeight();        //log({slide});
    updateTopCoordinates();

    if($("body").hasClass('template-index')){
      var t_spacing = sectionHeight / 2 - 100;
      var m_spacing = t_spacing;

      if($(window).width() < 980) {
        m_spacing = t_spacing + 85;
        $(section).css({
          // 'transform': 'translateY(-200px)',
          // 'margin-bottom': '-280px'
        });
      } else {
        $(section).css({
          // 'transform': 'translateY(-' + t_spacing + 'px)',
          // 'margin-bottom': '-' + m_spacing + 'px'
        });
      }
    }
  }, 100);


  $(slide).hide().eq(0).show();
  $(document).scroll();

  //video auto play
  var scroll_position = setInterval(function(){
    if ( $(document).scrollTop() >= (sectionHeight/2) ) {
      $('.embed_container').each(function(idx){
        console.log("EMbed", idx);
        var $embed = $(this);
        var $videoForm = $(this).find('.section-video_form');

        var _videoForm = null;
        
        $videoForm.each(function(idx){
            if($(this).hasClass('hide--mobile')) {
              if($(window).width() > 989) {
                _videoForm = $(this);
              }
            }
            else if($(this).hasClass('hide--desktop')) {
              if($(window).width() <= 989) {
                _videoForm = $(this);
              }
            }
            else {
              _videoForm = $(this);
            }
        })

        if(_videoForm.hasClass('video')) {
          var $video = _videoForm.find('#videoId');
          if($video.attr('data-autoplay') != 'false' && typeof(_videoForm.find("#videoId").get(0)) != 'undefined') {
            _videoForm.find("#videoId").get(0).play();
            _videoForm.closest('.embed_container').find('[data-video-replay]').hide();

            _videoForm.find('#videoId').on('ended', function(){
              _videoForm.closest('.embed_container').find('[data-video-replay]').show();
            })
          }
        }
        else if(_videoForm.hasClass('external_video')) {
          var $video = _videoForm.find('iframe');

          if (_videoForm.hasClass('vimeo')) {
            player = new Vimeo.Player($video);
          } else if (_videoForm.hasClass('youtube')) {
            if (window.YT !== undefined && window.YT.Player !== undefined) {}
              player = new YT.Player($($video).attr('id'));
          }

          var src = $video.attr('src');
          if($video.attr('data-autoplay') != 'false'){
            if($(window).width() > 767) {
              src += '?rel=0&loop=1&title=0&portrait=0&autoplay=1&playsinline=1&muted=1';
            }
            else {
              src += '?rel=0&loop=0&title=0&portrait=0&autoplay=1&playsinline=1&muted=1&showinfo=0&controls=0';
            }
          }
          $video.attr('src', src);
        }
        if($video.attr('data-autoplay') != 'false') {
          $(this).find('.video_pause_icon').attr('style','display: block;');
          $(this).find('.video_start_icon').attr('style','display: none;');
        }
      })
      clearInterval(scroll_position);
    }
  }, 100);
}

const getSectionHeight = () => {
  return pageHeight * $(slide).length;
}

const showSlide = index => {
  $(slide).each(function (i, element) {
    if (index === 'all') {
      $(element).show();
    } else {
      if (index == i) {
        $(element).show();
      } else {
        $(element).hide();
      }
    }
  });
}


$(document).on('click', '[data-video-replay]', function(){
  var $target = $(this).closest('.embed_container').find('.section-video_form.hide--desktop');
  if($(this).attr('data-selector') == 'all') {
    $target = $(this).closest('.embed_container').find('.section-video_form');
  }
  var $video = $target.find("#videoId");
  $video.get(0).play();
  $(this).hide();
  $video.find('#videoId').on('ended', function(){
    $video.closest('.embed_container').find('[data-video-replay]').show();
  })
})

$('.video_pause_icon').on('click', function () {
  var $parent = $(this).closest('.embed_container');
  var $videoForm = $parent.find('.section-video_form');
  if($videoForm.hasClass('video')) {
    $parent.find('#videoId').get(0).pause();
  }
  else if($videoForm.hasClass('external_video')) {
    var $video = $parent.find('iframe');
    var src = $video.attr('src');
    src = (src.split('?'))[0];
    $video.attr('src', src);
  }
  $parent.find('.video_pause_icon').attr('style','display: none;');
  $parent.find('.video_start_icon').attr('style','display: block;');
});

$('.video_start_icon').on('click', function () {
  var $parent = $(this).closest('.embed_container');
  var $videoForm = $parent.find('.section-video_form');

  if($videoForm.hasClass('video')) {
    $parent.find('#videoId').get(0).play();
    changeIcon();
  }
  else if($videoForm.hasClass('external_video')) {
    const videos = $parent.find('.section-video_form iframe');

    $(videos).each((index, item) => {
      if (isVisible($(item))) {
        if(typeof player.play == 'function') {
          player.play().catch(function (error) {
            console.error(error);
          });

          changeButton();
        } else if (typeof player.playVideo =='function') {
          console.log(player)
          player.playVideo();

          changeButton();
        }
      }
    })
  }

 function changeIcon () {
   $parent.find('.video_pause_icon').attr('style','display: block;');
   $parent.find('.video_start_icon').attr('style','display: none;');
 }

  function changeButton () {
    $parent.find('.video_play').attr('style','display: none;');
  }
});

const updateTopCoordinates = () => {
  topCoordinates = [];
  const sectionTop = $(section).offset().top;
  for (let i = 0; i < $(slide).length; i++) {
    topCoordinates.push(sectionTop + pageHeight*i)
  }
}

function scrollHandler() {
  var windowHeight = $(window).height();

  $(document).scroll(function () {
    var scrollTop = $(document).scrollTop();

    var $video = $('[data-video-wrapper][data-scroll-play]');

    $video.each(function () {
      var $this = $(this);
      var $target;
      var handle = $this.attr('data-type');
      var pos_t = $this.offset().top;

      if (handle == 'video') {
        $target = $this.find('video');
      }
      else if (handle == 'external_video') {
        $target = $this.find('iframe');
      }

      if(!$target) return;

      if (scrollTop + windowHeight > pos_t) {
        if (scrollTop < pos_t + $target.height()) {
          if ($this.attr('data-screen') != 'off' && $this.attr('data-play') != 'true') {
            if (handle == 'video') {
              $target.get(0).play();
            }
            else if (handle == 'external_video') {
              if (typeof playExternalVideo === "function") {
                playExternalVideo($target);
              }
            }
            $this.attr('data-play', 'true');
          }
        }
        else {
          $this.attr('data-screen', 'off');
        }
      }
    })
  })
}

const videoPlay = function (options) {
  if ($(section).length) {
    init();
    scrollHandler()
  }
};

export default videoPlay;